import React from 'react';
import './App.css';
import theme from 'styles/themes/theme';
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import { ThemeProvider } from '@mui/material/styles';
import { Layout } from 'components/Layout';
import Login from 'components/Login/Login';
import NotFound from 'components/NotFound/NotFound';
import ErrorBoundary from 'app/components/ErrorBoundary/ErrorBoundary';
import { ToastContainer } from 'react-toastify';
import { DocumentsPage } from 'pages/DocumentsPage';
import { TemplatesPage } from 'pages/TemplatesPage';
import { SettingsPage } from 'pages/SettingsPage';
import { DocumentViewerPage } from 'pages/DocumentViewerPage';
import HomePage from 'pages/Home/HomePage';
import AuthSalesforceCanvas from 'features/auth/components/AuthSalesforceCanvas/AuthSalesforceCanvas';
import ProtectedRoute from 'features/auth/components/ProtectedRoute/ProtectedRoute';
import 'react-toastify/dist/ReactToastify.css';
import { DndProvider } from 'react-dnd';
import { HTML5Backend } from 'react-dnd-html5-backend';
import BuilderLayout from 'components/BuilderLayout/BuilderLayout';
import SalesforceHome from 'pages/SalesforceHome/SalesforceHome';
import { ProtectedRouteWithRole } from 'features/auth/components/ProtectedRouteWithRole/ProtectedRouteWithRole';
import { UserRoles } from 'features/auth/authTypes';

export const appAccessRoles = [UserRoles.ADMIN, UserRoles.EDITOR];

function App() {
  const getProtectedRoute = (path: string, requiredRoles: string[], component: React.ReactNode) => {
    return (
      <Route
        path={path}
        element={<ProtectedRouteWithRole requiredRoles={requiredRoles}>{component}</ProtectedRouteWithRole>}
      />
    );
  };

  return (
    <ThemeProvider theme={theme}>
      <DndProvider debugMode={true} backend={HTML5Backend}>
        <ToastContainer position='top-center' />
        <BrowserRouter>
          <ErrorBoundary>
            <Routes>
              <Route path='login' element={<Login />} />
              <Route path='salesforce-auth-successful' element={<SalesforceHome />} />
              <Route path='salesforce-home' element={<SalesforceHome skipValidation />} />
              <Route element={<AuthSalesforceCanvas />}>
                <Route element={<ProtectedRoute />}>
                  <Route element={<Layout />}>
                    <Route
                      index
                      element={
                        <ProtectedRouteWithRole requiredRoles={appAccessRoles}>
                          <HomePage />
                        </ProtectedRouteWithRole>
                      }
                    />
                    {getProtectedRoute('documents', appAccessRoles, <DocumentsPage />)}
                    {getProtectedRoute('templates', appAccessRoles, <TemplatesPage />)}
                    {getProtectedRoute('settings', [UserRoles.ADMIN], <SettingsPage />)}
                  </Route>
                  <Route path='documents'>
                    {getProtectedRoute('create/:type', appAccessRoles, <BuilderLayout />)}
                    {getProtectedRoute('edit/:type/:id', appAccessRoles, <BuilderLayout />)}
                    {getProtectedRoute('view/:type/:id', appAccessRoles, <DocumentViewerPage />)}
                  </Route>
                  <Route path='templates'>
                    {getProtectedRoute('create/:type', appAccessRoles, <BuilderLayout />)}
                    {getProtectedRoute('edit/:type/:id', appAccessRoles, <BuilderLayout />)}
                  </Route>
                </Route>
              </Route>
              <Route path={'*'} element={<NotFound />} />
            </Routes>
          </ErrorBoundary>
        </BrowserRouter>
      </DndProvider>
    </ThemeProvider>
  );
}

export default App;
